import { milliseconds, minutesToSeconds } from 'date-fns';
import { type JwtPayload, jwtDecode } from 'jwt-decode';

/** Token refresh buffer - refresh tokens this many seconds before expiry */
export const TOKEN_REFRESH_BUFFER_SECONDS = minutesToSeconds(5);

const TOKEN_REFRESH_BUFFER_MS = milliseconds({ seconds: TOKEN_REFRESH_BUFFER_SECONDS });

export function isTokenExpiringSoon(token: string): boolean {
  try {
    const payload = jwtDecode<JwtPayload>(token);
    if (!payload?.exp) return true;

    const expiresAtMs = payload.exp * 1000; // JWT exp is in seconds
    return Date.now() > expiresAtMs - TOKEN_REFRESH_BUFFER_MS;
  } catch {
    return true; // Invalid token
  }
}

export function getTokenExpiration(token: string): number | null {
  try {
    const payload = jwtDecode<JwtPayload>(token);
    return payload?.exp ?? null;
  } catch {
    return null;
  }
}
